import { useState, useEffect, useCallback } from 'react';
import { usePppApi } from '../services/pppApi';

export function usePubblicazioni(procedimentoId, filtri = {}) {
  const api = usePppApi();
  const [pubblicazioni, setPubblicazioni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    if (!procedimentoId) return;
    setLoading(true);
    api.listPubblicazioni(procedimentoId, filtri, {
      onSuccess: (data) => { setPubblicazioni(data); setLoading(false); },
      onError:   (err)  => { setError(err); setLoading(false); },
    });
  }, [procedimentoId, filtri.fase, filtri.tipoPubblicazione, filtri.canale]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  return { pubblicazioni, loading, error, refresh: fetch };
}

export function useChecklistPubblicazioni(procedimentoId) {
  const api = usePppApi();
  const [checklist, setChecklist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    if (!procedimentoId) return;
    setLoading(true);
    api.getChecklistPubblicazioni(procedimentoId, {
      onSuccess: (data) => { setChecklist(data); setLoading(false); },
      onError:   (err)  => { setError(err); setLoading(false); },
    });
  }, [procedimentoId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  return { checklist, loading, error, refresh: fetch };
}
